import React, { useState } from 'react';
import styled from 'styled-components';
import Measure from 'react-measure';
import { curves, urlBarHeight } from '../styles/theme';
import { themify } from '../styles/mixins';
import { withSpacing } from '../lib/hoc/withSpacing';
import { ScrollArrow } from './ScrollArrow';
const StyledWrapper = styled.div.withConfig({
  displayName: "Wrapper__StyledWrapper",
  componentId: "wbr6y9-0"
})(["position:", ";top:", ";left:0;width:100%;height:", ";min-height:", ";overflow-x:hidden;overflow-y:", ";background:", ";text-align:", ";transform:", ";transition:all 0.2s ", ";"], x => x.absolute ? 'absolute' : 'relative', x => x.hasSubNav ? x.subNavOffset : x.offsetTop, x => `calc(100% - ${x.offsetTop || x.navbarHeight} - ${x.offsetBottom} - ${x.hasSubNav ? x.subNavOffset : '0px'})`, x => x.forceFullHeight || x.mobile ? `calc(100vh - ${urlBarHeight()}px)` : 'auto', x => x.overflowY, x => x.bgColor, x => x.textAlign, x => `translateX(${x.offsetLeft || `calc(-1 * ${x.offsetRight})`})`, curves.standard);

const WrapperFunc = ({
  absolute,
  bgColor,
  children,
  className,
  'data-tour': dataTour,
  hasSubNav,
  forceFullHeight,
  mobile,
  navbarHeight,
  offsetBottom,
  offsetLeft,
  offsetRight,
  offsetTop,
  overflowY,
  showArrow,
  style,
  subNavHeight,
  textAlign
}) => {
  const [scrollable, setScrollable] = useState(false);
  const subNavOffset = mobile ? `calc(1.5 * ${subNavHeight})` : subNavHeight;
  return /*#__PURE__*/React.createElement(Measure, {
    client: true,
    scroll: true,
    onResize: contentRect => {
      setScrollable(contentRect.scroll.height > contentRect.client.height);
    }
  }, ({
    measureRef
  }) => /*#__PURE__*/React.createElement(StyledWrapper, {
    id: "contentWrapper",
    absolute: absolute,
    bgColor: themify(bgColor),
    className: className,
    "data-tour": dataTour,
    forceFullHeight: forceFullHeight,
    hasSubNav: hasSubNav,
    ref: measureRef,
    mobile: mobile,
    navbarHeight: navbarHeight,
    offsetBottom: offsetBottom,
    offsetLeft: offsetLeft,
    offsetRight: offsetRight,
    offsetTop: offsetTop,
    overflowY: overflowY,
    style: style,
    subNavOffset: subNavOffset || '',
    textAlign: textAlign
  }, children, !mobile && scrollable && showArrow && /*#__PURE__*/React.createElement(ScrollArrow, null)));
};

WrapperFunc.defaultProps = {
  absolute: false,
  hasNavbar: true,
  hasSubNav: false,
  navbarHeight: '72px',
  overflowY: 'auto',
  offsetBottom: '0px',
  offsetLeft: '0px',
  offsetRight: '0px',
  offsetTop: '0px',
  subNavHeight: '36px',
  textAlign: 'left'
};
export const Wrapper = withSpacing(WrapperFunc);